import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Button, Typography } from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import "firebase/firestore";
import { doc, setDoc } from "firebase/firestore";
import * as React from "react";
import { createContext, useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { db } from "../../api/firebase";
import { getDates, nbfOrderItems, nbfcreatOrder } from "../../api/restApi";
import OverlayLoader from "../../components/modals/OverlayLoader";
import { setOrdersDate } from "../../store/reducer/ordersSlice";
import { useAppDispatch } from "../../utils/hooks";
import CustomAutocomplete from "../../components/AutoComplete";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { resolveUnitPriceForCustomer } from "../../utils/helpers";

const useStyles = makeStyles((theme) => ({
  datePickerContainer: {
    // minWidth: '310px', // Default value for extra-small screens
    // [theme.breakpoints.up('md')]: {
    //   minWidth: '480px', // For medium screens and above
    // },
    height: "55px",
  },
  datePicker: {
    minWidth: "310px", // Default value for extra-small screens
    [theme.breakpoints.up("md")]: {
      minWidth: "480px", // For medium screens and above
    },
    height: "55px",
    // backgroundColor: "#1976D2",
    fontWeight: "bold",
    color: "black",
    textAlign: "center",
    fontSize: "18px",
  },
}));

export default function CreateOrder() {
  const classes = useStyles();
  const customer = useSelector((state) => state.customers.customers);
  const product = useSelector((state) => state.products.products);
  const name = useSelector((state) => state.currentUser.name);
  console.log(name);
  const role = useSelector((state) => state.currentUser.role);
  const dispatch = useAppDispatch();
  const [createdOrders, setCreatedOrders] = useState([]);
  const [products, setProducts] = useState([]);
  const [orderItems, setOrderItems] = useState([]);
  const [showOrders, setShowOrders] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [openLoader, setOpenLoader] = useState(false);
  const { t } = useTranslation();
  const isMediumScreen = useMediaQuery("(min-width: 960px)"); 
  const [isEditing, setIsEditing] = useState(null);

  const [startDate, setStartDate] = useState(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
  });

  const componentRef = useRef();

  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formattedDate = formatDate(startDate);

  useEffect(() => {
    if (role === "cs") {
      const cusDropDown = customer
        .filter((customer) => customer.id == name)
        .map((customer) => {
          const data = {
            id: customer.id,
            ...customer,
          };
          data["label"] = data.name_english + " " + data.name_urdu;
          return data;
        });

      handleSelectCustomer("event", cusDropDown[0]);
      console.log(cusDropDown);
    }
  }, [role]);

  let CustomerDropdown;
  if (role !== "cs") {
    CustomerDropdown = customer.map((customer) => {
      const data = {
        id: customer.id,
        ...customer,
      };
      data["label"] = data.name_english + " " + data.name_urdu;
      return data;
    });
  }

  const ProductDropdown = product.map((product) => {
    const data = {
      id: product.id,
      ...product,
    };
    data["label"] = data.name_english + " " + data.name_urdu;
    return data;
  });

  useEffect(() => {
    resetOrderItem();
  }, [products]);
  const resetOrderItem = () => {
    setOrderItems([]);
  };

  if (role === "cs") {
  }

const handleSelectCustomer = async (event, newValue) => {
  setOpenLoader(false);
  try {
    setSelectedCustomer(newValue);

    // Check if the customer already has orders for the selected date
    let selectedCustomerOrders = await nbfOrderItems(formattedDate, newValue?.id);

    if (selectedCustomerOrders.length > 0) {
      // Customer already has orders, show a popup message
      Swal.fire({
        icon: "warning",
        title: "Customer already has orders for today",
        text: "Please check order status before adding new items.",
      });
      return;
    }

    // If no existing orders, proceed to set order items
    setOrderItems([]);
    setShowOrders(true);
    setOpenLoader(false);
  } catch (error) {
    setOpenLoader(false);
    console.error("Error selecting customer:", error);
    toast.error("Error selecting customer", {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  }
};


const handleSelectProduct = (event, newValue) => {
  setSelectedProduct(newValue);
  const existingItem = orderItems.find((item) => item.id === newValue?.id);
  setQuantity(existingItem?.quantity || "");
};

  const addProduct = () => {
    if (!selectedCustomer || !selectedProduct || isNaN(quantity) || quantity <= 0) {
      return;
    }

    const newQuantity = parseFloat(quantity);
    let tempArray = [...orderItems];
    const unitPrice = resolveUnitPriceForCustomer(selectedProduct, selectedCustomer);

    if (isEditing !== null) {
      // Edit existing item
      tempArray[isEditing] = {
        ...tempArray[isEditing],
        quantity: newQuantity,
        price: unitPrice,
      };
      setIsEditing(null); // Reset editing state
    } else {
      // Add new item
      const index = tempArray.findIndex((item) => item.id === selectedProduct.id);
      if (index > -1) {
        tempArray[index].quantity += newQuantity; // Update existing item quantity
        tempArray[index].price = unitPrice;
      } else {
        tempArray.push({
          ...selectedProduct,
          price: unitPrice,
          quantity: newQuantity,
        });
      }
    }

    setOrderItems(tempArray);
    setQuantity("");
    setSelectedProduct(null);
  };


  const handleCancel = async () => {
    if (orderItems.length == 0) {
      return;
    }

    const confirmed = await Swal.fire({
      title: "Do you want to Cancel ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    });
    if (confirmed.isConfirmed) {
      setSelectedCustomer(null);
      setShowOrders(false);
    }
  };

  const handleSaveOrder = async () => {
    // Get the current time
    const currentTime = new Date();
    const currentHour = currentTime.getHours();

    // Check if the current time is after 9 PM (21:00)
    if (role === "cs" && currentHour >= 13) {
      // Show an alert that order cannot be saved after 9 PM
      alert("Sorry not allowed  order after 9 : 00 PM.");
      return;
    }

    // Proceed with saving the order
    if (orderItems.length === 0) {
      return;
    }
    const confirmed = await Swal.fire({
      title: "Do you want to Save Order ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    });
    if (confirmed.isConfirmed) {
      setIsLoading(true);
      try {
        const customerId = selectedCustomer.id;
        await nbfcreatOrder(orderItems, customerId, formattedDate);
  
        // Creating empty fields
        await setDoc(doc(db, "Order", formattedDate), {
          dummy: "",
        });
  
        // Clear the selected customer, hide the order form, and reset order items
        toast.success("Successfully Saved Products!", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
  
        setSelectedCustomer(null);
        setOrderItems([]); // Clear the table after saving the order
        let datesofOrders = await getDates();
        dispatch(setOrdersDate(datesofOrders));
        setShowOrders(false);
      } catch (error) {
        console.error("Error saving order: ", error);
        toast.error("Error saving order", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
      e.preventDefault();

      const currentId = parseInt(document.activeElement.id, 10);
      const nextId =
        e.key === "ArrowRight" ? (currentId + 1) % 6 : (currentId + 5) % 6;

      const nextElement = document.getElementById(nextId.toString());

      if (nextElement) {
        nextElement.focus();
      }
    }
  };

  console.log(CustomerDropdown, ProductDropdown);

  const nbfRole = localStorage.getItem("nbf_role");
  

  const handleDeleteItem = (index) => {
    Swal.fire({
      title: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedItems = [...orderItems];
        updatedItems.splice(index, 1);
        setOrderItems(updatedItems);
      }
    });
  };
  const handleEditItem = (index) => {
    setIsEditing(index);
    setSelectedProduct(orderItems[index]);
    setQuantity(orderItems[index].quantity);
  };
  
  return (
    <div>
      <Box sx={{ flexGrow: 0, padding: "1rem" }}>
        {/*********** Left-side-card ***************/}
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Card
              variant="outlined"
              sx={{
                width: "100%",
                height: isMediumScreen ? "75vh" : "50vh",
                mt: isMediumScreen ? 4 : 0,
              }}
            >
              <form
                onSubmit={(e) => e.preventDefault()}
                onKeyDown={handleKeyDown}
              >
                <CardContent>
                  <Stack alignItems="center" spacing={0}>
                    <Stack
                      flex="1"
                      justifyContent="center"
                      alignItems="center"
                      spacing={1}
                      direction="row"
                      marginBottom="1rem"
                    >
                      <label
                        style={{ minWidth: isMediumScreen ? "240px" : "150px" }}
                      >
                        <Button
                          id="0"
                          variant="contained"
                          color="error"
                          sx={{ minWidth: "100%" }}
                          onClick={handleCancel}
                        >
                          {t("Cancel")} {/* Cancel */}
                        </Button>
                      </label>
                      <label
                        style={{ minWidth: isMediumScreen ? "240px" : "150px" }}
                      >
                        <Button
                          id="1"
                          variant="contained"
                          sx={{ minWidth: "100%" }}
                          onClick={handleSaveOrder}
                          color="success"
                        >
                          {isLoading ? (
                            <CircularProgress
                              sx={{ color: "#fff" }}
                              size={30}
                            />
                          ) : (
                            t("Save Order")
                          )}
                        </Button>
                      </label>
                    </Stack>

                    <Stack
                      alignItems="center"
                      spacing={1}
                      direction="row"
                      marginBottom="1rem"
                      marginTop="0.5rem"
                    >
                      <div
                        className={classes.datePickerContainer}
                        style={{ zIndex: 999 }}
                      >
                        {nbfRole === "cs" ? (
                          <DatePicker
                            className={classes.datePicker}
                            selected={startDate}
                            // onChange={(date) => setStartDate(date)}
                            minDate={new Date()}
                            readOnly
                          />
                        ) : (
                          <DatePicker
                            className={classes.datePicker}
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            minDate={new Date()}
                          />
                        )}
                      </div>
                    </Stack>

                    <Stack
                      alignItems="center"
                      spacing={1}
                      direction="row"
                      marginBottom="1rem"
                    >
                      <label
                        style={{ minWidth: isMediumScreen ? "480px" : "310px" }}
                      >
                        {role === "cs" ? (
                          <CustomAutocomplete
                            id="1"
                            value={selectedCustomer}
                            label={t("Customer")}
                            readOnly
                          />
                        ) : (
                          <CustomAutocomplete
                            id="2"
                            options={CustomerDropdown}
                            value={selectedCustomer}
                            onChange={handleSelectCustomer}
                            label={t("Customer")}
                          />
                        )}
                      </label>
                    </Stack>
                  </Stack>

                  <Stack
                    flex="1"
                    justifyContent="center"
                    alignItems="center"
                    spacing={1}
                    direction="row"
                    marginBottom="1rem"
                  >
                    <label
                      style={{ minWidth: isMediumScreen ? "240px" : "150px" }}
                    >
                      <CustomAutocomplete
                        id="3"
                        options={ProductDropdown}
                        value={selectedProduct}
                        onChange={handleSelectProduct}
                        label={t("Products")}
                      />
                    </label>
                    <label
                      style={{ minWidth: isMediumScreen ? "240px" : "150px" }}
                    >
                      <TextField
                        style={{ width: "100%" }}
                        value={quantity || ""}
                        type="number"
                        onChange={(event) => setQuantity(event.target.value)}
                        id="4"
                        label={t("Quantity")}
                        variant="outlined"
                      />
                    </label>
                  </Stack>
                  <Stack
                    flex="1"
                    justifyContent="center"
                    alignItems="center"
                    spacing={1}
                    direction="row"
                    marginBottom="1rem"
                  >
                    <label
                      style={{ minWidth: isMediumScreen ? "480px" : "310px" }}
                    >
                      <Button
                        id="5"
                        variant="contained"
                        sx={{ minWidth: "100%", height: "40px" }}
                        onClick={addProduct}
                        size="small"
                      >
                        {t("Add Products")}
                        {/* Add Product */}
                      </Button>
                    </label>
                  </Stack>
                </CardContent>
              </form>
            </Card>
          </Grid>

          {/*********  right-side-card  ************* */}

          <Grid item xs={12} md={6}>
            <Card
              variant="outlined"
              sx={{
                width: "100%",
                height: isMediumScreen ? "75vh" : "50vh",
                mt: isMediumScreen ? 4 : 0,
                overflowY: "auto",
              }}
            >
              <CardContent>
                
              <Stack
                          justifyContent="center"
                          alignItems="center"
                          spacing={1}
                          direction={"row"}
                          marginBottom="1rem"
                        >
                          <label
                            style={{
                              minWidth: isMediumScreen ? "240px" : "150px",
                            }}
                          >
                            <Typography
                              fontSize={"18px"}
                              fontWeight="bold"
                              color={"#1976D2"}
                              textAlign={"start"}
                              borderBottom="0.3px solid gray"
                            >
                              {selectedCustomer?.name_english}
                            </Typography>
                          </label>
                          <label
                            style={{
                              minWidth: isMediumScreen ? "240px" : "150px",
                            }}
                          >
                            <Typography
                              fontSize={"18px"}
                              fontWeight="bold"
                              color={"#1976D2"}
                              textAlign={"end"}
                              borderBottom="0.3px solid gray"
                            >
                              {selectedCustomer?.name_urdu}
                            </Typography>
                          </label>
                        </Stack>
              {orderItems.length > 0 ? (
                <Table>
                  <TableBody>
                    {orderItems.map((item, index) => (
                      <TableRow key={item.id}>
                        <TableCell>{item.name_english}</TableCell>
                        <TableCell>{item.name_urdu}</TableCell>
                        <TableCell>{item.quantity}</TableCell>
                        <TableCell>
                          <IconButton
                            color="primary"
                            onClick={() => handleEditItem(index)}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            color="secondary"
                            onClick={() => handleDeleteItem(index)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography></Typography>
              )}
            </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
      <OverlayLoader open={openLoader} />
    </div>
  );
}